var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"container-fluid footer clearfix\"><p>{{'© restaurant.ninja' + ' 2015'}}</p></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/shell/footer/footer.jade
// module id = 154
// module chunks = 0